import { useGtm } from '@gtm-support/vue2-gtm';

import store from '~store';

export function triggerGtmEvent(
  {
    event,
    data,
  }: {
    event: string;
    data: object;
  },
): void {
  const gtm = useGtm();

  gtm?.trackEvent?.({
    ...data,
    event,
  });
}

export function triggerGtmPaymentFinalizedEvent(
  providerName: string,
): void {
  const getters = store?.getters;

  function formatCentToEuro(centValue : number) {
    return (centValue / 100).toFixed(2);
  }

  const configDistribution = getters.getConfigDistribution;
  const voucherPrepaid = getters.getVoucherPrepaid;
  const voucherDistribution = getters.getVoucherDistribution;
  const voucherValueInCent = getters.getVoucher.valueInCent;
  const voucherCurrency = getters.getVoucherCurrency;
  const voucherValueInEuro = formatCentToEuro(voucherValueInCent);
  const voucherBalanceInCent = getters.getVoucher.balanceInCent;
  const voucherBalanceInEuro = formatCentToEuro(voucherBalanceInCent);
  const voucherTopUpValueInCent = voucherBalanceInCent - voucherValueInCent;
  const voucherTopUpValueInEuro = formatCentToEuro(voucherTopUpValueInCent);
  const voucherCategoryId = getters.getVoucherCategoryId;
  const category = getters.getCategory;
  const data = {
    providerName,
    configDistribution,
    voucherPrepaid,
    voucherDistribution,
    voucherValueInCent,
    voucherValueInEuro,
    voucherBalanceInCent,
    voucherBalanceInEuro,
    voucherTopUpValueInCent,
    voucherTopUpValueInEuro,
    voucherCurrency,
    voucherCategoryId,
    category,
  };

  triggerGtmEvent({
    event: 'top-up-redemption',
    data,
  });
}
